import { GET_CDC_CARD_ERROR, GET_CDC_CARD_START, GET_CDC_CARD_SUCCESS } from "../../types";

export default function card_category(state, action) {
  switch (action.type) {
    case GET_CDC_CARD_START:
      return {
        ...state,
        data: [],
        loading: true,
        error: null
      };
    case GET_CDC_CARD_SUCCESS:
      return {
        ...state,
        data: action.results,
        loading: false,
        error: null
      };
    case GET_CDC_CARD_ERROR:
      return {
        ...state,
        data: [],
        loading: false,
        error: action.detail
      };
    default:
      return { ...state };
  }
}
